var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-file-input',{ref:"inputUploader",attrs:{"label":_vm.label,"multiple":true,"color":"#ffa500","type":"file","name":"files"},on:{"change":_vm.onChange,"click:clear":function($event){_vm.reset();_vm.$emit('reset', true);}},model:{value:(_vm.images),callback:function ($$v) {_vm.images=$$v},expression:"images"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }